import { render, staticRenderFns } from "./dealerOfOneself.vue?vue&type=template&id=3710813c&scoped=true"
import script from "./dealerOfOneself.vue?vue&type=script&lang=js"
export * from "./dealerOfOneself.vue?vue&type=script&lang=js"
import style0 from "./dealerOfOneself.vue?vue&type=style&index=0&id=3710813c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710813c",
  null
  
)

export default component.exports